import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import { useIdentity } from "@/context/SiteConfigContext";

// Reusable "independent private corporate services provider" disclosure.
export default function ComplianceNote({ className = "" }) {
  const { legalName } = useIdentity();
  const { t } = useTranslation();
  return (
    <div className={`rounded-sm border border-border bg-secondary/50 p-4 flex items-start gap-3 text-sm text-muted-foreground ${className}`} data-testid="compliance-note">
      <ShieldCheck className="h-4 w-4 text-orange-600 mt-0.5 shrink-0" />
      <span>
        <strong className="text-foreground font-medium">{t("disclaimer.noteTitle", { name: legalName, defaultValue: `${legalName} is an independent private corporate services provider.` })}</strong>{" "}
        {t("disclaimer.noteBody", { defaultValue: "We are not a government agency, registry, bank or regulatory authority. We assist clients with company incorporation and related corporate services through applicable service providers and jurisdictions." })}
      </span>
    </div>
  );
}
